// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import md5 from 'js-md5';
import Vant from 'vant';
import { Lazyload } from 'vant';
import './assets/common.css'
import './assets/autoSize.js'
import 'vant/lib/index.css';
Vue.use(Vant).use(Lazyload);

// 根据路由设置标题
router.beforeEach((to, from, next) => {
    /*路由发生改变修改页面的title */
    if(to.meta.title) {
      document.title = to.meta.title
    }
    next();
})

Vue.prototype.$axios = axios
Vue.prototype.$md5 = md5
axios.defaults.baseURL = 'https://laia-api.yeedian365.com:19443/laia_api/interfaces/';
axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js